<template>
  <transition name="el-fade-in">
    <div class="scroll-contain" v-show="toTopShow" @click="scrollToTop">
      <i class="el-icon-arrow-up"></i>
      <div>返回顶部</div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      toTopShow: false,
      scrollTop: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
    });
  },
  destroyed() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll: function() {
      this.scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop; // 兼容写法
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop: function() {
      let timer = null;
      const _this = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 0) {
          if (_this.scrollTop > 5000) {
            _this.scrollTop -= 1000;
          } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
            _this.scrollTop -= 500;
          } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
            _this.scrollTop -= 100;
          } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
            _this.scrollTop -= 10;
          } else if (_this.scrollTop > 5 && _this.scrollTop <= 50) {
            _this.scrollTop -= 5;
          } else {
            _this.scrollTop = 0;
          }
          _this.$options.methods.setScrollTop(_this.scrollTop);
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _this.toTopShow = false;
        }
      });
    },
    setScrollTop: function(scrollTop) {
      const isBodyScrollTop =
        document.body.scrollTop > document.documentElement.scrollTop;
      if (isBodyScrollTop) document.body.scrollTop = scrollTop;
      else document.documentElement.scrollTop = scrollTop;
    }
  }
};
</script>

<style scoped lang="less">
.scroll-contain {
  position: fixed;
  bottom: 10%;
  right: 5%;
  background: #adadad;
  width: 60px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #fff;
  i {
    font-size: 20px;
    line-height: 16px;
  }
  div {
    font-size: 12px;
    padding-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollTop.vue